/**
 * UUID v4 con fallback para entornos sin `crypto.randomUUID`.
 */

export function uuidv4(): string {
  const c: { randomUUID?: () => string; getRandomValues?: (a: Uint8Array) => Uint8Array } | undefined =
    typeof crypto !== 'undefined' ? (crypto as unknown as Record<string, never>) : undefined;

  if (c && typeof c.randomUUID === 'function') return c.randomUUID();

  // Fallback con getRandomValues (browsers desde 2014).
  const bytes = new Uint8Array(16);
  if (c?.getRandomValues) c.getRandomValues(bytes);
  else for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);

  // v4 + variant bits
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
}
